enum SatisfiedStatusEnum {
    Satisfied = 'SATISFIED',
    Unsatisfied = 'UNSATISFIED',
}

export default SatisfiedStatusEnum;
